import axios from "axios";

// Tạo instance chung cho mọi request
const API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL + '/api',
  withCredentials: true,
});

// =========================
// AUTH
// =========================
export const login = (email, password) => API.post("/auth/login", { email, password });
export const logout = () => API.post("/auth/logout");
export const checkAuth = () => API.get("/auth/check");
export const health = () => API.get("/health");

// =========================
// SETTINGS
// =========================
export const getSettings = () => API.get("/settings");
export const updateSettings = (data) => API.patch("/settings", data);

// =========================
// COURSES
// =========================
export const getCourses = () => API.get("/courses");
export const getCourseDetail = (slug) => API.get(`/courses/${slug}`);
export const createCourse = (formData) => 
  API.post("/courses", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    withCredentials: true
  });

export const getCoursesAdmin = () => {
  return API.get("/courses/admin", { withCredentials: true });
};
export const getCourseById = (id) => API.get(`/admin/courses/${id}`, { withCredentials: true });

export const updateCourse = (id, formData) => 
  API.patch(`/courses/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    withCredentials: true
  });

export const deleteCourse = (id) => 
  API.delete(`/courses/${id}`, { withCredentials: true });

// =========================
// POSTS
// =========================
export const getPosts = () => API.get("/posts");
export const getPostDetail = (slug) => API.get(`/posts/${slug}`);
export const createPost = (data) => API.post("/posts", data);
export const getPostsAdmin = () => {
  return API.get("/posts/admin", { withCredentials: true });
};
export const getPostById = (id) => API.get(`admin/posts/${id}`);
export const updatePost = (id, formData) => 
  API.patch(`/posts/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
export const deletePost = (id) => API.delete(`/posts/${id}`);


// =========================
// GUIDES
// =========================
export const getGuides = () => API.get("/guides");
export const getGuidesAdmin = () => API.get("/admin/guides", { withCredentials: true });
export const getGuideById = (id) =>
  API.get(`/admin/guides/${id}`, { withCredentials: true });
export const createGuide = (formData) =>
  API.post("/guides", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    withCredentials: true,
  });
export const updateGuide = (id, formData) =>
  API.patch(`/guides/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    withCredentials: true,
  });
export const deleteGuide = (id) =>
  API.delete(`/guides/${id}`, { withCredentials: true });

// =========================
// UPLOADS
// =========================
export const uploadImage = (formData) =>
  API.post("/uploads", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

// =========================
// CONTACTS
// =========================
export const createContact = (data) => API.post("/contacts", data);
export const processContact = (id, data) =>
  API.patch(`/contacts/${id}/process`, data);
export const getContacts = () => API.get("/contacts");

export default API;